var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebcallOutgoing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.334,
    height: 9.334,
    viewBox: "0 0 9.334 9.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#44bf3d",
    d: "M89.192,181.807a.483.483,0,0,0-.684,0l-7.539,7.535V185.2a.5.5,0,0,0-.412-.494.485.485,0,0,0-.558.48v5.33a.486.486,0,0,0,.485.484h4.834a.5.5,0,0,0,.495-.412.485.485,0,0,0-.48-.557h-3.68l7.539-7.535A.488.488,0,0,0,89.192,181.807Z",
    transform: "translate(89.334 191) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcallOutgoing);
export default __webpack_public_path__ + "static/media/webcall-outgoing.7425aab55ae6789489531451976c06b6.svg";
export { ForwardRef as ReactComponent };